import { ContainerTruckCarrier } from '@api/queries/inventory';
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import DetailsInput from './DetailsInput';

interface Props extends WithTranslation {
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  containerTruck?: ContainerTruckCarrier;
  trafficOut: boolean;
  isDisabled?: boolean;
}

const ContainerTruck = ({ isDisabled, containerTruck, onChange, t }: Props) => {
  const { licencePlate, containerNumber, billOfLandingNumber } = containerTruck || {
    licencePlate: '',
    containerNumber: '',
    billOfLandingNumber: ''
  };

  return (
    <>
      <DetailsInput
        name="containerNumber"
        label={t('entry.containerTruck.container_number')}
        isDisabled={isDisabled}
        value={containerNumber}
        onChange={onChange}
      />
      <DetailsInput
        name="licencePlate"
        label={t('entry.containerTruck.licence_plate')}
        isDisabled={isDisabled}
        value={licencePlate}
        onChange={onChange}
      />
      <DetailsInput
        name="billOfLandingNumber"
        label={t('entry.containerTruck.bill_of_landing_number')}
        isDisabled={isDisabled}
        value={billOfLandingNumber}
        onChange={onChange}
      />
    </>
  );
};

export default withTranslation()(ContainerTruck);
